import { events } from "../../js/state-machine";
import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";

export const componentName = "Dropdown";

export const defaultProps = Object.freeze({
    selection: "single",
    noOptionsLabel: "No options found",
    selectedLabel: "selected",
    srClearLabel: "clear selected options",
    selectAll: true,
    selectAllLabel: "Select all",
});

export const schema = Object.freeze({
    selection: matchers.or(matchers.eq("single"), matchers.eq("multiple")),
    noOptionsLabel: matchers.string,
    selectedLabel: matchers.string,
    srClearLabel: matchers.string,
    selectAll: matchers.boolean,
    selectAllLabel: matchers.string,
});

export const eventMap = Object.freeze({
    selectionChange: events.selectionChange(componentName),
});

export const componentClasses = Object.freeze({
    base: `${prefix}dropdown`,
    isOpen: `${prefix}dropdown--is-open`,
    isMultiple: `${prefix}dropdown--is-multiple`,
    isPressing: `${prefix}dropdown--is-pressing`,
    sizes: {
        sm: `${prefix}dropdown--sm`,
        lg: "",
    },
    inputContainer: `${prefix}dropdown__input-container`,
    inputWrapper: `${prefix}dropdown__input-wrapper`,
    inputField: `${prefix}dropdown__input-field`,
    inputFieldHidden: `${prefix}dropdown__input-field-hidden`,
    tag: `${prefix}dropdown__tag`,
    chevron: `${prefix}dropdown__chevron`,
    popup: {
        base: `${prefix}dropdown__popup`,
        positioning: `${prefix}dropdown__popup--positioning`,
        visible: `${prefix}dropdown__popup--visible`,
        hidden: `${prefix}dropdown__popup--hidden`,
    },
    list: {
        base: `${prefix}dropdown__list`,
        empty: `${prefix}dropdown__list--empty`,
    },
    group: `${prefix}dropdown__group`,
    groupTitle: `${prefix}dropdown__group-title`,
    item: `${prefix}dropdown__item`,
    itemOption: `${prefix}dropdown__item-option`,
    itemSelected: `${prefix}dropdown__item-selected`,
    itemLabel: `${prefix}dropdown__item-label`,
    notice: `${prefix}dropdown__notice`,
    selectAll: `${prefix}dropdown__select-all`,
    listItemSeparator: `${prefix}dropdown__list-separator`,
});

export const views = Object.freeze({
    base: {
        isOpen: { classList: [componentClasses.isOpen] },
        isClose: { classList: [`!${componentClasses.isOpen}`] },
        isMultiple: { classList: [componentClasses.isMultiple] },
        isPressing: { classList: [componentClasses.isPressing] },
        isNotPressing: { classList: [`!${componentClasses.isPressing}`] },
    },
    selectAll: {
        base: { attrs: { "aria-hidden": null } },
        hidden: { attrs: { "aria-hidden": "true" } },
    },
    popup: {
        positioning: {
            classList: [
                componentClasses.popup.positioning,
                `!${componentClasses.popup.visible}`,
                `!${componentClasses.popup.hidden}`,
            ],
        },
        visible: {
            classList: [
                componentClasses.popup.visible,
                `!${componentClasses.popup.positioning}`,
                `!${componentClasses.popup.hidden}`,
            ],
        },
        hidden: {
            classList: [
                componentClasses.popup.hidden,
                `!${componentClasses.popup.positioning}`,
                `!${componentClasses.popup.visible}`,
            ],
        },
    },
    list: {
        base: { classList: [`!${componentClasses.list.empty}`] },
        empty: { classList: [componentClasses.list.empty] },
    },
    tag: {
        base: { attrs: { "aria-hidden": "true" } },
        visible: { attrs: { "aria-hidden": "false" } },
    },
    item: {
        base: { attrs: { "aria-hidden": null, role: "option" } },
        group: { attrs: { "aria-hidden": null, role: "group" } },
        selected: { attrs: { "data-selected": "true", "aria-selected": "true" } },
        notSelected: { attrs: { "data-selected": "false", "aria-selected": "false" } },
        checked: { attrs: { "data-selected": "true", "aria-checked": "true" } },
        notchecked: { attrs: { "data-selected": "false", "aria-checked": "false" } },
        mixed: { attrs: { "data-selected": "mixed", "aria-checked": "mixed" } },
        hidden: {
            attrs: {
                "aria-hidden": "true",
                "aria-posinset": null,
                "aria-setsize": null,
                role: "none",
            },
        },
    },
    notice: {
        base: { attrs: { "aria-hidden": "true" } },
        visible: { attrs: { "aria-hidden": "false" } },
    },
});
